import { ELEMENT_TYPE } from "./constants";
// 把自定义元素转成html元素
/**
 * @param elem 元素的数据结构，如上文的 Resume
 * @param childrenHtml 子节点的 HTML 代码
 * @returns 元素的 HTML 字符串
 */
const elemToHtml = (elem, childrenHtml) => {
  const { url = "" } = elem;
  // 生成 HTML 代码，data-w-e-type用于标记元素类型，后面会用
  const html = `<div data-w-e-type="${ELEMENT_TYPE}" data-url="${url}">
    <img src="${url}" alt=""></img>
  </div>`;
  return html;
};

// 编辑器输出html配置
export const elemToHtmlConfig = {
  type: ELEMENT_TYPE,
  elemToHtml: elemToHtml,
};
